import React from "react";
import OBHavingTroubleCard from "../../onboarding/_components/OBHavingTroubleCard";
import AddAccountForm from "./AddAccountForm";

const PaymentAccountSection = () => {
  return (
    <div>
      {/* <AddAccountForm /> */}
      {/* <OBHavingTroubleCard /> */}
    </div>
  );
};

export default PaymentAccountSection;
